import { ManageColumnsHub } from "./ui/ManageColumnsHub";

interface BriefCustomFieldsProps {
  onClose?: () => void;
}

export function BriefCustomFields({ onClose }: BriefCustomFieldsProps) {
  return <ManageColumnsHub onClose={onClose} />;
}
